<template>
  <el-dialog
    :title="$t('account.password.title')"
    width="488px"
    :visible="show"
    @close="handleCancle"
    class="modify-login-password-dialog"
  >
    <el-form
      :model="formData"
      :rules="formRules"
      ref="form"
      class="horizontal"
      label-position="left"
      label-width="86px"
    >
      <el-form-item :label="$t('account.password.legacyOld')" prop="password">
        <el-input
          type="password"
          v-model="formData.password"
          :placeholder="$t('common.inputPlaceholder')"
        ></el-input>
      </el-form-item>
      <el-form-item :label="$t('account.password.legacyNew')" prop="newPassword">
        <el-input
          type="password"
          v-model="formData.newPassword"
          :placeholder="$t('common.inputPlaceholder')"
        ></el-input>
      </el-form-item>
    </el-form>
    <div class="dialog__actions" style="text-align: right">
      <el-button @click="handleCancle">{{ $t('common.cancel') }}</el-button>
      <el-button
        type="primary"
        class="button-medium"
        @click="handleChangePassword"
        >{{ $t('common.confirmModify') }}</el-button
      >
    </div>
  </el-dialog>
</template>

<script>
import * as accountApi from '@/apis/account'

export default {
  name: 'modifyLoginPasswordDialog',
  props: {
    show: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      formData: {},
    }
  },
  computed: {
    formRules() {
      return {
        password: [
          { required: true, message: this.$t('account.password.oldEmpty'), trigger: 'change' },
          {
            pattern: '^[a-zA-Z0-9]{6,16}$',
            message: this.$t('account.password.patternOld'),
          },
        ],
        newPassword: [
          { required: true, message: this.$t('account.password.newEmpty'), trigger: 'change' },
          {
            pattern: /(?!^[0-9]{8,16}$)(?!^[a-zA-Z]{8,16}$)^[0-9a-zA-Z]{8,16}$/,
            message: this.$t('account.password.patternNew'),
            trigger: 'change',
          },
        ],
      }
    },
  },
  methods: {
    handleCancle() {
      this.$emit('update:show', false)
    },
    handleChangePassword() {
      this.$refs.form.validate((val) => {
        if (val) {
          if (this.formData.password === this.formData.newPassword) {
            this.$message.error(this.$t('account.password.samePassword'))
          } else {
            const { password, newPassword } = this.formData
            const params = {
              password,
              newPassword,
            }
            accountApi.modifyLoginAccount(params).then((res) => {
              if (res) {
                this.$message.success(this.$t('account.password.modifySuccess'))
                this.handleCancle()
              }
            })
          }
        }
      })
    },
  },
}
</script>
